import { EntityBase } from "./entity-base.model";
import { Company } from "./company.model";
export class Branch extends EntityBase {
  public Code: number;
  public Title: string;
  public LatinTitle: string;
  public CompanyId: number;
  public Comment: string;
  public LatinComment: string;
  public ParticipationPercentage: number;
  public Company: Company;
  public CompanyTitle: string;
  public CompanyLatinTitle: string;
  public PhoneNumber: string;
  public EconomicalNumber: string;
  public PostalCode: string;
  public CustomerTitles: string[];
  public TaxPercentage: number;
  public TollPercentage: number;
  public ServicePercentage: number;
  public StandardDelayTimeForPreparation: number;
  public AlertDelayTimeForPreparation: number;
  public TimeForChange: number;
  public AddSettlementForUnpaidAndSuspendedInvoices: boolean;
  public RoundingAmount: number;
  public RoundingTypeId: number;
  public RoundingTypeTitle: string;
  public RoundingTypeCode?: number;
  public ShippingCostReducedKindId: number;
  public ShippingCostReducedKindTitle: string;
  public ShippingCostReducedKindCode?: number;
  public Message: string;
  public DisplayLogoInPrintTemplates: boolean;
  public DisplayAddressInInvoice: boolean;
  public IgnoreBlackBackground: boolean;
  public ShowTotalCalories: boolean;
  public CurrencyId: number;
  public CurrencyTitle: string;
  public CurrencyCode?: number;
  // public SmsApiKey: string;
  // public SmsAdvertisingNumber: string;
  // public SmsServiceNumber: string;
  public EnableCreateCustomerSms: boolean;
  public EnableAssignToDriverSms: boolean;
  public AccessToAllBranches: boolean;
  public InvDailyBalanceInhibitorId: number;
  public BranchDataTransferInfos: BranchDataTransferInfo[];
  public HasOrderOnline: boolean;
  public ReadyToReceiveOnlineOrders: boolean;
  public AutoPrintCash: boolean;
  public AutoPrintOnline: boolean;
  public CustomerPrintOrderOnile: boolean;
  public HasDecimal: boolean;
  public HasLocalService: boolean;
  public HasAuditorInSalesAmounts: boolean;
  public HasTotalDebit: boolean;
  public NoDisplayDashboard: boolean;
  public FoodTruck: boolean;
  public SendVoucherFromCenter: boolean;
  public Number: string;
  public LocalServiceIp: string;
  public PaymentType: number;
  public StencilBranchId: number;
  public Suspend: boolean;
  public IsActive: boolean;
  public Latitude: number;
  public Longitude: number;
  public multiOrder: Boolean;
  public BranchAddress: string;
  public HasAccounting: boolean;
  public DetailLedgerId: number;
  public TransferDebtorsTypeId: number;
  public TransferDebtorsTypeTitle: string;
  public TransferDebtorsTypeCode?: number;
  public DebtorsSubLedgerId: number;
  public SendingSalesTypeId: number;
  public SendingSalesTypeTitle: string;
  public SendingSalesTypeCode?: number;
  public TaxPayerToken: string;
  public PrivateTaxPayerToken: string;
  public ProtelAddress: string;
  public SendingCashierTypeId: number;
  public SendingCashierTypeTitle: string;
  public SendingCashierTypeCode?: number;
  public SendingSalesTitle: string | string[];
  public NationalCode: string;
  public AccVoucherSeparatedByDay: boolean;
  public ApplyServicesForFee: boolean;
  public InvWarehouseId: number;
  public FullScreenView: boolean;
  public ServiceId?: number;
  public PackingPriceId: number;
  public ShipingCostId:number;

  constructor() {
    super();
    this.TaxPercentage = 0;
    this.TollPercentage = 0;
    this.ServicePercentage = 0;
    this.StandardDelayTimeForPreparation = 0;
    this.AlertDelayTimeForPreparation = 0;
    this.RoundingAmount = 0;
    this.ParticipationPercentage = 0;
    this.StencilBranchId = 0;
    this.Latitude = 0;
    this.Longitude = 0;
    this.DetailLedgerId = null;
    this.InvWarehouseId = null;
  }
}

export class BranchDataTransferInfo extends EntityBase {
  public BranchId: number;
  public OppositeBranchUrl: string;
  public OppositeBranchId: number;
  public OrignalOppositeBranchId: number;
  public OppositeBranchTitle: string;
  public IsCentralOffice: boolean;
  public StartHour1?: number;
  public EndHour1?: number;
  public StartHour2?: number;
  public EndHour2?: number;
  public StartHour3?: number;
  public EndHour3?: number;
  public InterruptTime: number;
  public TopRecordCount: number;
  public TransferAccountingCode: boolean;
  public Number: string;
  public TranslateCost: boolean;
}
